/* global storageAvailable */
var localStorageAvailable = storageAvailable.checkLocalStorage();

jQuery(document).ready(function() {
    var consentStored = localStorageAvailable ? localStorage.getItem('cookie_consent_v1') : null;
    var $bannerContainer = jQuery('#cookie_consent');

    if ($bannerContainer) {
        var $consentButton = $bannerContainer.find(".bocss-button");
        if (consentStored !== null) {
            $bannerContainer.addClass('hidden');
        }

        $consentButton.on('click', function(event) {
            event.preventDefault();
            if (localStorageAvailable) {
                localStorage.setItem('cookie_consent_v1', Date.now());
            }
            $bannerContainer.removeClass('bocss-banner--active').addClass('hidden');
        });
    }
});
